<template>
  <f7-page id="transaction-history-details-page" name="transaction-history-details-page" @page:beforeout="handleBeforeOut()" @page:afterin="afterin">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>
    <f7-block>

      <!-- PAGE TITLE -->
      <div class="col-70 text-align-left mb-20">
        <div class="wandr-title-1">{{$t(pageTitle)}}</div>
      </div>

      <!-- TRANSACTION DETAILS -->
      <div class="card card-20 payment-summary">
          <div class="payment-details">
            <div>
              <div>{{$t('my-transaction-transfer-no')}}</div>
              <div>{{transaction.transactionId}}</div>
            </div>
            <div class="pb-0">
              <div>{{dateCreated}}</div>
              <div class="col-status badge" :class="'badge-'+ (deliveryStatusId == 80 ? 10 : deliveryStatusId)">{{transaction.transactionStatusName}}</div>
            </div>
          </div>
          <div class="payment-details payment-details-10">
            <div>
              <div>{{$t('sendmoney-text-recipient')}}</div>
              <div class="fw-bold">{{transaction.beneficiaryFullName}}</div>
            </div>
            <div v-if="paymentMethod">
              <div>{{$t('sendmoney-label-payment-method')}}</div>
              <div>
                {{paymentMethod}}
              </div>
            </div>
            <div>
              <div class="pb-0">{{$t('my-transaction-settlement-no')}}</div>
              <div>S{{transaction.settlementId}}</div>
            </div>
          </div>
          <div class="payment-details payment-details-4">
            <div>
              <div class="wandr-level-3">{{$t('sendmoney-label-recipient-receives')}}</div>
              <div class="wandr-level-3">{{this.formatCurrency(transaction.homeAmount, 2) || 0}} {{transaction.homeCurrency}}</div>
            </div>
            <div class="text-color-gray">
              <div>{{$t('general-text-exchange-rate')}}</div>
              <div>{{ (rateBaseCurrencyId == 189) ? transaction.hostCurrency + " / " + transaction.homeCurrency : transaction.homeCurrency + " / " + transaction.hostCurrency }}  {{activeDisplayRate}}</div>
            </div>
          </div>
          <div class="payment-details2 pt-20 pb-md">
            <div>
              <div class="wandr-level-3">{{$t(labelYouPay)}}</div>
              <div class="wandr-level-3"> {{this.formatCurrency(totalPayable, 2) || 0}} {{transaction.hostCurrency}}</div>
            </div>
          </div>
      </div>

      <!-- ALERT CARD -->
      <f7-card
        :title  ="$t(alertCard.title)"
        class  ="alert"
        :class ="alertCard.alertClass"
        id     ="successCard"
        v-show ="alertCard.show"
      >
          <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
      </f7-card>

      <!-- TRANSACTION PROCESS -->
      <f7-row class="mt-lg">
        <f7-col class="b font-size-130">{{$t('general-text-transaction-process')}}</f7-col>
        <f7-col class="text-align-right" v-show="transaction.allowToModify == true" @click="navigateTo('modify-transaction')">
          <a href="#">{{$t('sendmoney-text-edit')}}</a>
        </f7-col>
      </f7-row>

      <!-- Vertical Stepper -->
      <div class="card card-20 mb-20">
        <div class="beneficiary-card display-flex align-items-center justify-content-space-between mb-xl">
          <div class="col-bank">
            <img :src="getBankImg(transaction.beneficiaryBankId)" style=""/>
          </div>
          <div class="col-details">
            <div class="wandr-level-3">{{transaction.beneficiaryFullName}}</div>

            <div class="wandr-caption-2" v-if="transaction.deliveryMethodId == 1 || transaction.deliveryMethodId == 6 || transaction.deliveryMethodId == 9">{{transaction.beneficiaryBank}} ({{transaction.bankAccountNo}})</div>
            <div class="wandr-caption-2" v-if="transaction.deliveryMethodId == 3">{{transaction.collectionAgent}}</div>
            <div class="wandr-caption-2" v-if="transaction.deliveryMethodId == 4">{{transaction.province}}&nbsp;&bull;&nbsp;{{transaction.city}}</div>
            <div class="wandr-caption-2" v-if="transaction.deliveryMethodId == 0">{{transaction.billingOrg}}&nbsp;&bull;&nbsp;{{transaction.bankAccountNo}}</div>
          </div>
          <div class="col-country">
            <img :src="getFlagImg(transaction.homeCountryId)"/>
          </div>
        </div>

        <!-- TRX PROGRESS STATUS -->
        <ul class="StepProgress">
          <li v-for="(progress, index) in stepProgress" :key="index"   :class="progress.class">
            <div :class="( (index == 'transit' || index == 'complete' || index == 'pay' ) && (progress.date.length == 0)  ) ? 'tx-progress-title text-color-gray' : 'tx-progress-title' " > {{$t(progress.title)}}</div>
            <div v-if=" index == 'create' " class="tx-progress-note fs-12">{{$t('my-transaction-transfer-no')}} {{transaction.transactionId}}</div>
            <div v-if=" index == 'pay' && agentPaymentStatusId >= 10 " class="tx-progress-note">{{paymentMethod}}</div>
            <div class="tx-progress-date">{{progress.date}}</div>
          </li>
        </ul>

      </div>
      <!-- end of vertical stepper -->

      <f7-button v-if="isShowBtnDownload" large fill @click="downloadInvoice()" > {{$t("general-text-download-"+buttonText)}} </f7-button>
      <f7-button v-if="isShowCancel" class="color-gray6 button-fill text-color-red mt-md" large outline @click="showCancelTrxModal= true">{{$t('general-text-cancel-transaction')}}</f7-button>
    </f7-block>

    <f7-sheet class="wandr-sheet-modal sheet-center sheet-24" :opened="showCancelTrxModal" @sheet:closed="showCancelTrxModal= false" :swipeToClose="true">
      <div class="modal-subtitle mb-md text-align-center">{{$t('sendmoney-cancel-transaction-confirm')}}</div>
      <div>
        <f7-button class="mt-22" large fill @click="cancelTransaction()">{{$t('general-btn-yes')}}</f7-button>
        <f7-button class="mt-22" large outline @click="showCancelTrxModal= false">{{$t('general-btn-no')}}</f7-button>
      </div>
    </f7-sheet>
  </f7-page>
</template>

<script>
  import { fxRateHelper as FX } from '@/plugins/helper'
  import { mapActions }         from "vuex"

  export default {

    data() {
        return{
            activeDisplayRate   : 0,
            agentPaymentStatusId: 0,
            alertCard           : { show: false, title: "transaction-edit-saved", content: "", alertClass:"alert-success" },
            beneficiaryBankId   : 0,
            buttonText          : 'invoice',
            dateCreated         : '',
            deliveryStatusId    : 0,
            deliveryStatusHistoryList : [],
            hostCurrency        : '',
            homeCurrency        : '',
            isShowCancel        : false,
            isShowBtnDownload   : true,
            isMakePayment       : false,
            isTrxPaid           : false,
            labelYouPay         : 'sendmoney-text-you-pay',
            pageTitle           : '',
            paymentMethod       : '',
            paymentDateTime     : '',
            rateBaseCurrencyId  : 0,
            showCancelTrxModal  : false,
            stepProgress        : {
              "create"          : { title:"general-text-category-transfer-created",   class: "StepProgress-item is-done", date: ""},
              "pay"             : { title:"general-text-category-payment-received",   class: "StepProgress-item",         date: ""},
              "transit"         : { title:"general-text-category-intransit",          class: "StepProgress-item",         date: ""},
              "complete"        : { title:"general-text-category-transfer-completed", class: "StepProgress-item",         date: ""}
            },
            totalPayable        : 0,
            transaction         : {}
        }
    },

    mounted (){

      const self = this;
      self.showPreloader()

      var transaction = self.$store.state.transaction;

      const transactionDetail = this.$api.transaction.getMyTransactionDetails(transaction.transactionId)
      transactionDetail.then(function(result) {
        // console.log("getMyTransactionDetails", result)
        const trxDetail = result[0]
        self.rateBaseCurrencyId   = trxDetail.exchangeRateBaseCurrencyId
        self.deliveryStatusId     = trxDetail.deliveryStatusId
        self.agentPaymentStatusId = trxDetail.agentPaymentStatusId
        self.homeCurrency         = trxDetail.homeCurrency
        self.hostCurrency         = trxDetail.hostCurrency
        self.activeDisplayRate    = FX.formatDisplayRate(trxDetail.exchangeRate, {countryId: trxDetail.homeCountryId, isDisplay: true})
        self.transaction          = transaction
        transaction.transactionStatusName = self.getDeliveryStatusName(trxDetail.deliveryStatusId, trxDetail.deliveryStatus, trxDetail.agentPaymentStatusId)
        self.isMakePayment        = transaction.isMakePayment

        self.totalPayable = parseFloat(trxDetail.hostAmount) + parseFloat(trxDetail.transactionCharges) - parseFloat(trxDetail.discountValue)

        if(self.isTrxModified != undefined && self.isTrxModified == true){
          self.alertCard.show = true;
        }

        // GET SETTLEMENT DETAILS
        if(trxDetail.settlementId > 0){
          const settlementDetails = self.$api.settlement.getSettlement(trxDetail.settlementId)
          settlementDetails.then(function(result) {
            // console.log("getSettlement", result)
            if(result.paymentList !=undefined && result.paymentList.length > 0){
              self.totalPayable    = parseFloat(self.totalPayable) + parseFloat(result.paymentList[0].fee || 0)
              self.paymentMethod   = result.paymentList[0].paymentMethod;
              transaction.paymentMethod = result.paymentList[0].paymentMethod;
              transaction.paymentMethodId  = result.paymentList[0].paymentMethodId;
            }
          })
        }

        if(trxDetail.transactionTypeId == 2){
          const getRemittanceDetailPromise = self.$api.transaction.getRemittance(trxDetail.transactionId)
          getRemittanceDetailPromise.then(function(remitResul) {
            trxDetail.paymentPurpose = remitResul.paymentPurpose
            self.deliveryStatusHistoryList = remitResul.deliveryStatusHistoryList
            self.setTransactionDetail(trxDetail)
            self.init()
            self.hidePreloader()
          })
        }else {
          const getBillPaymentPromise = self.$api.transaction.getBillPayment(trxDetail.transactionId)
          getBillPaymentPromise.then(function(billResult) {

            trxDetail.paymentPurpose = billResult.paymentPurpose
            if( trxDetail.deliveryMethodId == 0){
              trxDetail.beneficiaryBank   = billResult.billingCorporation
            }
            self.deliveryStatusHistoryList = billResult.deliveryStatusHistoryList
            self.setTransactionDetail(trxDetail)
            self.init()
            self.hidePreloader()
          })
        }
      })

    },

    props: {
      isTrxModified: Boolean
    },

    methods: {
      ...mapActions('transaction', [ 'setTransactionDetail' ]),
        init(){
          const self = this;

          self.dateCreated = self.getDateFormat(self.transaction.createdDateTime, false)
          self.buttonText  = ( self.transaction.deliveryStatusId >=10 && self.transaction.agentPaymentStatusId > 5 ) ?  'receipt': 'invoice';

          let classDone         = " StepProgress-item is-done"
          let classCancel       = " StepProgress-item is-cancel"
          let classHide         = " d-none"
          const statusId        = self.transaction.deliveryStatusId
          const paymentStatusId = self.transaction.agentPaymentStatusId
          const daStatusId      = self.transaction.distributionPaymentStatusId

          self.stepProgress['create'].date  = self.getDateFormat(self.transaction.createdDateTime, true);

          var dateUpdated = ""
          if(statusId > 10 && statusId != 80){
            if(self.transaction.deliveryDateTime != undefined && self.transaction.deliveryDateTime.year != 0){
              dateUpdated  = self.getDateFormat(self.transaction.deliveryDateTime, true);
            }else if(self.transaction.paymentDateTime != undefined && self.transaction.paymentDateTime.year > 0){
              dateUpdated  = self.getDateFormat(self.transaction.paymentDateTime, true);
            }

            self.stepProgress['transit'].date = dateUpdated
          }

          self.labelYouPay = ( statusId >= 10 && (paymentStatusId == 5|| paymentStatusId == 2) ) ? 'sendmoney-text-you-pay' : 'sendmoney-text-you-paid'
          self.isTrxPaid   = ( statusId >= 10 && (paymentStatusId == 5|| paymentStatusId == 2) ) ?  false : true

          switch(statusId){
            case 10:
              self.isShowCancel                    = (self.transaction.settlementStatusId == 210) ? true : false;
              if(paymentStatusId == 5|| paymentStatusId == 2 ){ //upaid
                self.stepProgress['pay'].class     = "StepProgress-item"

                self.pageTitle                       = 'sendmoney-page-title-transfer-created'
              }else{
                self.stepProgress['create'].class  = classDone
                self.stepProgress['pay'].class     = classDone

                self.pageTitle                       = 'sendmoney-page-title-in-transit'
              }
              break;
            case 35:
              self.stepProgress['create'].class    = classDone
              self.stepProgress['pay'].class       = classDone
              self.stepProgress['transit'].class   = classDone

              self.pageTitle                       = 'sendmoney-page-title-in-transit'
              break;
            case 40:
              self.stepProgress['create'].class    = classDone
              self.stepProgress['pay'].class       = classDone
              self.stepProgress['transit'].class   = classDone
              self.stepProgress['complete'].class  = classDone
              self.stepProgress['complete'].date   = dateUpdated

              self.pageTitle                       = 'sendmoney-page-title-transfer-completed'
              break;
            case 50:
              self.stepProgress['create'].class    = classDone
              self.stepProgress['pay'].class       = classDone
              self.stepProgress['transit'].class   = classDone
              self.stepProgress['complete'].class  = classCancel
              self.stepProgress['complete'].title  = "sendmoney-step-transfer-unsuccessful"
              self.stepProgress['complete'].date   = dateUpdated
              self.isShowCancel                    = (self.transaction.settlementStatusId == 210) ? true : false;
              self.pageTitle                       = 'sendmoney-page-title-transfer-unsuccessful'

              break;
            case 60:
              // console.log("Case 60 : cancelled")
              self.isShowCancel                      = false;
              self.isShowBtnDownload                 = false;
              self.stepProgress['create'].class      = classDone
              self.stepProgress['complete'].date     = self.getDateFormat(self.transaction.deliveryDateTime, true);

              if(paymentStatusId < 10){ //Cancellation before pay
                self.stepProgress['pay'].class       = classHide
                self.stepProgress['transit'].class   = classHide
                self.stepProgress['complete'].class  = classCancel
                self.stepProgress['complete'].isShow = true
                self.stepProgress['complete'].title  = "sendmoney-step-transfer-cancelled"
              } else if (daStatusId == 90) { //Cancellation after transaction failed
                self.stepProgress['pay'].class       = classDone
                self.stepProgress['transit'].class   = classCancel
                self.stepProgress['complete'].class  = classCancel
                self.stepProgress['transit'].title   = "sendmoney-step-transfer-unsuccessful"
                self.stepProgress['complete'].title  = "sendmoney-step-transfer-cancelled"
              } else { //Cancellation after pay
                self.stepProgress['pay'].class       = classDone
                self.stepProgress['transit'].class   = classHide
                self.stepProgress['complete'].class  = classCancel
                self.stepProgress['complete'].title  = "sendmoney-step-transfer-cancelled"
              }
              self.pageTitle                         = 'sendmoney-page-title-transfer-cancelled'

              break
            case 70:
              // console.log("Case 70")
              self.stepProgress['create'].class    = classDone
              self.stepProgress['pay'].class       = classDone
              self.stepProgress['transit'].class   = classCancel
              self.stepProgress['transit'].title   = "sendmoney-step-transfer-cancelled"
              self.stepProgress['complete'].class  = classDone
              self.stepProgress['complete'].title  = "sendmoney-step-transfer-refunded"
              self.stepProgress['complete'].date   = dateUpdated
              self.isShowBtnDownload               = false
              self.pageTitle                       = 'sendmoney-page-title-transfer-refunded'
              
              break;
            case 80:
              /*
              //suspended
              self.stepProgress['pay'].class       = classHide
              self.stepProgress['transit'].class   = classHide
              self.stepProgress['complete'].class  = classCancel
              self.stepProgress['complete'].isShow = true
              self.stepProgress['complete'].title  = "sendmoney-step-transfer-suspended"

              self.pageTitle                         = 'sendmoney-page-title-transfer-suspended'

              
              break;
              */
              self.isShowCancel                    = (self.transaction.settlementStatusId == 210) ? true : false;
              if(paymentStatusId == 5|| paymentStatusId == 2 ){ //upaid
                self.stepProgress['pay'].class     = "StepProgress-item"

                self.pageTitle                       = 'sendmoney-page-title-transfer-created'
              }else{
                self.stepProgress['create'].class  = classDone
                self.stepProgress['pay'].class     = classDone

                self.pageTitle                       = 'sendmoney-page-title-in-transit'
              }
              break;
          }

          if(self.agentPaymentStatusId >=10 && self.transaction.paymentDateTime != undefined && self.transaction.paymentDateTime.year > 0){
            self.stepProgress['pay'].class = classDone;
            self.stepProgress['pay'].date  = self.getDateFormat(self.transaction.paymentDateTime, true)
          }

          self.deliveryStatusHistoryList.forEach(function (item) {
            var dateUpdated = self.getDateFormat(item.updatedDateTime, true)

            switch(item.statusId){
              
              case 35:
                self.stepProgress['transit'].date    = dateUpdated
                break;
              case 40:
                self.stepProgress['complete'].date   = dateUpdated
                break;
              case 50:
                self.stepProgress['complete'].date   = dateUpdated
                break;
              case 60:
                self.stepProgress['complete'].date  = dateUpdated
                break
              case 70:
                self.stepProgress['complete'].date   = dateUpdated
                break;
              /*case 80:
                self.stepProgress['complete'].date   = dateUpdated
                break;
              */
            }
          });
        },

        afterin(){
          window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
        },

        async downloadInvoice(){
          this.showPreloader();
          try{
            let fileName = "Wandr-E_" + this.transaction.transactionId + "_" + this.buttonText + ".pdf"
            const result = await this.$api.transaction.generateInvoice(this.transaction.transactionId);

            this.hidePreloader();
            if(result === undefined || result.length <= 0) {
              this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
              return false;
            }

            if(window.Android) {
              window.Android.getWandrCallback(JSON.stringify({ "type": 'save_pdf_file', "filename":fileName, 'data': result.base64,'message': "Invoice Downloaded" }));
            } else if(window.webkit) {
              window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": 'save_pdf_file', "filename": fileName , 'data': result.base64 }));
            } else {
              const dwnElement = document.createElement('a');
              dwnElement.download = fileName;
              dwnElement.href = "data:application/pdf;base64," + result.base64;
              document.body.append()
              dwnElement.click()     //click to download
              dwnElement.remove()    //remove created element after download
            }
            if(window.Android) {
              // console.log("skip here")
            }else{
              this.$f7.toast.create({
              text: this.buttonText + ' downloaded',
              position: 'center',
              closeTimeout: 1000,
              }).open()
            }
          } catch(e){
            this.hidePreloader();
            this.$f7.dialog.alert(e.message);
          }
        },

        cancelTransaction(){
          const self = this
          try {
            self.showPreloader()
            const cancelTransactionRequest = self.$api.transaction.cancelTransaction( self.transaction.transactionId, self.transaction.transactionTypeId )
            cancelTransactionRequest.then(function(result) {
              if(!result.invalid){
                self.$f7router.navigate("/transaction-history" , { props: { isTrxCancelled: true }});
              }
              self.showCancelTrxModal = false
              self.hidePreloader()
            });
          } catch(e){
            self.hidePreloader()
          }
        },

        formatCurrency(num, dec) {
          let val = (Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100).toFixed(dec)
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        navigateTo(page){
          if(page == 'modify-transaction'){
            this.alertCard.show = false;
            this.$f7router.navigate("/transaction-modify" , { transition: 'f7-push'});
          }
        },

        backButton() {
          if(this.isTrxModified){
            this.$f7router.navigate("/home", { transition: 'f7-fade', clearPreviousHistory  : true });
          }else{

            if(this.isMakePayment && this.isTrxPaid){
              this.$f7router.back("/transaction-history",{force:true})
            }else{
              this.$f7router.back({ transition: 'f7-push' });
            }
          }
        },

        handleBeforeOut(){
          var transaction = this.$store.state.transaction;
          transaction.deliveryStatusHistoryList  = null
          transaction.deliveryDateTime  = {year:0, month:0, dayOfMonth:0, hourOfDay:0, minute:0,second:0}
          transaction.paymentDateTime   = {year:0, month:0, dayOfMonth:0, hourOfDay:0, minute:0,second:0}
        }
    }
  }
</script>
